/* This is hack to work around problem for our IOS wrapper app (it moves whole WebView up 20px)
 */

import { useLayoutEffect } from 'react';

export const IOS_WRAPPER_LAYOUT_CUTOFF = 20;
const useIOSLayoutFix = (iosThemeEnabled: boolean): void => {
  // In iOS wrapper, to hide status bar out layout is extended by 20px and moved up by 20px
  // Like this <rect key="frame" x="0.0" y="-20" width="1024" height="788"/>
  // So we have use this hack in order for web app layout not to be cutoff by 20px on top
  useLayoutEffect(() => {
    if (iosThemeEnabled) {
      document.body.style.paddingTop = `${IOS_WRAPPER_LAYOUT_CUTOFF}px`;
    }
  }, [iosThemeEnabled]);
};
export default useIOSLayoutFix;
